<template>
  <div class="usdt_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.push('/user')"
      />
      <div class="big_tit">
        {{ $t('income.title') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/moneybag')"
      >
        <van-icon
          name="bars"
          size="25"
        />
      </div>
    </div>
    <div class="grid-wrap">
      <a
        class="grid-item"
        @click="$router.push('/invest2')"
      >
        <div class="link-body"><h3 class="link-title">{{ $t('income.jichu') }}</h3></div>
        <div class="link-foot">{{ $t('income.jichud') }}</div>
      </a>
      <a
        class="grid-item"
        @click="$router.push('/invest')"
      >
        <div class="link-body"><h3 class="link-title">{{ $t('income.tui') }}</h3></div>
        <div class="link-foot">{{ $t('income.tuid') }}</div>
      </a>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
    import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import bsHeader from '../../components/bsHeader.vue'
	import Clipboard from 'v-clipboard';
	import {
		Icon
	} from 'vant';
	Vue.use(Clipboard).use(Icon);
    export default {
        name: "Pay",
        data() {
            return {
                data: null,
                money: 0,
            };
        },
        created() {
            this.$parent.footer('user', true);
        },
        mounted() {
        },
        methods: {
           
        }
    };
</script>

<style lang="less" scoped>
	.grid-wrap {
	    display: grid;
		margin: 10px;
	}
	.link-body {
	    height: 100px;
	    background: no-repeat center/100% 100%;
	    padding-top: 20px;
	    padding-left: 20px;
	}
	.grid-item:first-child .link-body {
	    color: #434f70;
	    background-image: url(../images/index/deposit.png)
	}
	
	.grid-item:last-child .link-body {
	    color: #794a4a;
	    background-image: url(../images/index/depositright.png)
	}
	
	.link-foot {
	    padding: 15px;
	    line-height: 18px;
	    color: #6d6d6d;
	}
	.link-title {
	    margin: 0 0 8px;
	    font-size: 16px;
	}
	
	.grid-item {
	    overflow: hidden;
	    display: block;
	    position: relative;
	    margin-bottom: 20px;
	    background-color: #fff;
	    box-shadow: 0 0 4px 0 #dedede;
		border-radius: 20px;
	}
	.usdt_wrap { min-height: 100vh; padding-bottom: calc(86px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); }.red_top_bg { height: 54px; background: rgba(255, 252, 245, .97); border-bottom: 1px solid rgba(190, 139, 52, .45); }.red_top_bg .big_tit, .red_top_bg .back_left, .red_top_bg .top_right { color: #873126; }
	.grid-wrap { margin: 16px 14px; }.grid-item { border: 1px solid rgba(190, 139, 52, .46); border-radius: 15px; background: #fffdf8; box-shadow: 0 9px 20px rgba(125, 82, 35, .08); }.link-body { height: 94px; padding: 22px 18px 0; background-color: #fff6e3; }.grid-item:first-child .link-body, .grid-item:last-child .link-body { color: #873126; background-image: none; background: linear-gradient(105deg, #fff7df, #f4d993); }.grid-item:last-child .link-body { background: linear-gradient(105deg, #fff0ed, #f2c7c9); }.link-title { font-size: 17px; }.link-foot { color: #815c45; }
</style>
